const VALID_MUI_MODES = new Set(["light", "dark", "system"])
const VALID_MUI_SCHEMES = new Set(["light", "dark"])

function removeIfInvalid(storage: Storage, key: string, validValues: Set<string>) {
  const currentValue = storage.getItem(key)

  if (currentValue && !validValues.has(currentValue)) {
    storage.removeItem(key)
  }
}

function resetIfInvalid(storage: Storage, key: string, fallback: "light" | "dark") {
  const currentValue = storage.getItem(key)

  if (currentValue && !VALID_MUI_SCHEMES.has(currentValue)) {
    storage.setItem(key, fallback)
  }
}

/**
 * Clears malformed MUI color-scheme storage values (for example "[object Object]")
 * that can trigger runtime warnings in MUI CssVarsProvider.
 */
export function sanitizeMuiColorSchemeStorage(storage: Storage) {
  removeIfInvalid(storage, "mui-mode", VALID_MUI_MODES)
  removeIfInvalid(storage, "mui-color-scheme", VALID_MUI_SCHEMES)
  resetIfInvalid(storage, "mui-color-scheme-light", "light")
  resetIfInvalid(storage, "mui-color-scheme-dark", "dark")
}

export function sanitizeMuiColorSchemeStorageFromWindow() {
  if (typeof window === "undefined") {
    return
  }

  try {
    sanitizeMuiColorSchemeStorage(window.localStorage)
  } catch {
    // Ignore environments that disallow localStorage access.
  }
}
